import classNames from 'classnames';
import { Container } from 'yoso';
import { LoginSecurity } from '~/components/Auth/Login/Security/LoginSecurity';
import { useChallengeEventHistories } from '~/components/Challenge/Event/ChallengeEvent.hooks';
import { ChallengeEventErrorFallback } from '~/components/Challenge/Event/Error/ChallengeEventErrorFallback';
import { ChallengeEventList } from '~/components/Challenge/Event/List/ChallengeEventList';
import { ChallengeEventSummary } from '~/components/Challenge/Event/Summary/ChallengeEventSummary';
import { ChallengeHeader } from '~/components/Challenge/Header/ChallengeHeader';
import { QueryErrorBoundary } from '~/components/Error';
import { Page, PageProps } from '~/components/Page';
import styles from './ChallengeEventPage.module.scss';

export type ChallengeEventPageProps = PageProps;

export const ChallengeEventPage = ({ className, ...props }: ChallengeEventPageProps) => {
  const { isFetched } = useChallengeEventHistories({
    keepPreviousData: true,
    initialData: undefined,
  });

  return (
    <Page
      className={classNames(styles.root, { [styles.preparing]: !isFetched }, className)}
      data-event-page_name="challenge_history_reward"
      data-event-category="challenge_history"
      {...props}>
      <Container margin="auto">
        <ChallengeHeader />
        <div className={styles.body}>
          <QueryErrorBoundary FallbackComponent={ChallengeEventErrorFallback}>
            <LoginSecurity>
              <ChallengeEventSummary />
              <ChallengeEventList className={styles.list} />
            </LoginSecurity>
          </QueryErrorBoundary>
        </div>
      </Container>
    </Page>
  );
};
